// クラシック版のダイアログと覆う画面（段階 C の2 の 7b。2026-10-26 に charat.common.js の setNowLoading・setNowMaking・setFirstCheck・openDialog・finishModal から描き直した。動きは前と同じ）。
// 読み込み中（#chaLoading）・作成中（#chaMaking）・はじめの確認（#chaFirstCheck、規約の吹き出しと START・CANCEL）・名前の入力と確認のダイアログ（#chaNameDialog）。
// 大きさ・CSS・フェード・クリックは jq.ts（jQuery と同じ決まり。2026-10-26 の 7g-2 から）。charat.common に置く
import { common } from './engine.js';
import * as jq from './jq.js';
import { tooltip } from './tooltip.js';

const C = (): Record<string, any> => common() as unknown as Record<string, any>;

/** 前の処理の名残（中身は無い） */
export function finishModal(): void {
  jq.ready(() => {
    // hover overlays disabled
  });
}

/** 読み込み中の画面。aLoading が true なら aWindow（覆う所のセレクタ）の真ん中に出し、false ならフェードで消す */
export function setNowLoading(aLoading: boolean, aWindow?: string): void {
  if (aLoading) {
    const areaHeight = jq.height(aWindow);
    const areaWidth = jq.width(aWindow);
    jq.setHeight('#chaLoading', areaHeight);
    jq.setCss('#chaLoading', 'top', (areaHeight - jq.height('#chaLoading img')) / 2);
    jq.setCss('#chaLoading', 'left', (areaWidth - jq.width('#chaLoading img')) / 2);
    jq.setCss('#chaLoadingBg, #chaLoading', 'display', 'block');
  } else {
    jq.fadeOut('#chaLoadingBg, #chaLoading', 400);
  }
}

/**
 * 作成中の画面。aMakeing が true なら aWindow の真ん中に出し、背景の黒の不透明度は anAlpha（画像は setNowMakingSrc か今の src に ?時刻 を付けて読み直す）。
 * false なら aDelay ミリ秒待って aDur ミリ秒でフェードで消し、背景が消え終わったら aCallBack。出すときは aDelay・aDur・aCallBack を使わない（前のまま）
 */
export function setNowMaking(aMakeing: boolean, anAlpha: number, aDelay: number, aDur: number, aWindow: string, aCallBack?: () => void): void {
  if (aMakeing) {
    const areaHeight = jq.height(aWindow);
    const areaWidth = jq.width(aWindow);
    const imgsrc = C().setNowMakingSrc != null ? C().setNowMakingSrc : jq.attr('#chaMaking img', 'src');
    jq.setAttr('#chaMaking img', 'src', imgsrc + '?' + new Date().getTime());
    jq.setHeight('#chaMaking', areaHeight);
    jq.setCss('#chaMaking', 'top', (areaHeight - jq.height('#chaMaking img')) / 2);
    jq.setCss('#chaMaking', 'left', (areaWidth - jq.width('#chaMaking img')) / 2);
    jq.setCss('#chaMakingBg', 'background-color', 'rgba(0,0,0,' + anAlpha + ')');
    jq.setCss('#chaMakingBg, #chaMaking', 'display', 'block');
  } else {
    jq.delay('#chaMakingBg, #chaMaking', aDelay);
    jq.fadeOut('#chaMakingBg, #chaMaking', aDur, function (this: Element) {
      if (this.getAttribute('id') == 'chaMakingBg' && aCallBack != undefined) aCallBack();
    });
  }
}

/**
 * はじめの確認: 「ガイドライン・利用規約を読んでください」の吹き出し（tippy）と START・CANCEL を出す（chibi.checkFirst がはじめの 1 回だけ呼ぶ）。
 * START で画面が消え終わったら aStartCallback、CANCEL で aCancelCallback
 */
export function setFirstCheck(aWindow: string, aStartCallback: () => void, aCancelCallback: () => void): void {
  const areaHeight = jq.height(aWindow);
  jq.setHeight('#chaFirstCheck', areaHeight);
  jq.setWidth('#chaFirstCheck', jq.width('#chaFirstCheckBg'));
  jq.setCss('#chaFirstCheck', 'top', (areaHeight - jq.height('#chaFirstCheck img')) / 2);
  jq.setCss('#chaFirstCheckBg', 'background-color', 'rgba(0,0,0,0.8)');
  jq.setCss('#chaFirstCheckBg, #chaFirstCheck', 'display', 'block');
  const message =
    typeof _t !== 'undefined' && _t && _t.first_visit
      ? _t.first_visit
      : 'Please read the "<a href="https://charat.me/en/guideline" target="_blank">Guidelines</a>" and "<a href="https://charat.me/en/terms" target="_blank">Terms of Service</a>".';
  tooltip('#chaFirstCheck > img', {
    content: message,
    interactive: true,
    placement: 'top',
    animation: 'shift-away',
    animateFill: true,
    duration: 500,
    flip: false,
    showOnInit: true,
    sticky: true,
    arrow: true,
    arrowType: 'sharp',
    trigger: 'manual',
    theme: 'firstmes',
    hideOnClick: false,
    zIndex: 9999,
    distance: 0,
  });
  jq.append('#chaFirstCheckButton', '<a class="startbutton disablebutton">START</a>');
  jq.append('#chaFirstCheckButton', '<a class="cancelbutton disablebutton">CANCEL</a>');
  jq.on('#chaFirstCheckButton > a.startbutton', 'click', () => {
    const img = document.querySelector('#chaFirstCheck > img') as Element & { _tippy: { hide(d: number): void; destroy(): void } };
    img._tippy.hide(0);
    img._tippy.destroy();
    jq.fadeOut('#chaFirstCheckBg, #chaFirstCheck', 500, () => {
      aStartCallback();
    });
  });
  jq.on('#chaFirstCheckButton > a.cancelbutton', 'click', () => {
    aCancelCallback();
  });
}

/**
 * 名前の入力（aMode "input"）・確認（"confirm"）のダイアログを開く。aMesList: input は [入力欄の値, 見出し, プレースホルダ, 注記 1, 注記 2]、confirm は [見出し, 注記]。
 * aChecked を渡すと「縁に沿って表示」のチェックを出してその値に。OK・キャンセルのクリックははじめの 1 回だけ付け、押したときの処理は今の aCallBackOK・aCallBackCancel
 */
export function openDialog(aMode: string, aMesList: unknown[], aCallBackOK?: () => void, aCallBackCancel?: () => void, aChecked?: boolean): void {
  const c = C();
  if (!c.openDialogInit) {
    jq.on('#chaNameDialogOK', 'click', () => {
      if (C().openDialogOk != undefined) C().openDialogOk();
      jq.setCss('#chaNameDialogBg', 'display', 'none');
    });
    // 前は "#chaNameDialogCancel, #chaNameDialogFrame, #chaNameDialogFrame"（同じ要素を 2 回書いても 1 つに数えて 1 回だけ付く）
    jq.on('#chaNameDialogCancel, #chaNameDialogFrame', 'click', () => {
      if (C().openDialogCancel != undefined) C().openDialogCancel();
      jq.setCss('#chaNameDialogBg', 'display', 'none');
    });
    c.openDialogInit = true;
  }
  c.openDialogOk = aCallBackOK;
  c.openDialogCancel = aCallBackCancel;
  let isValid = false;
  if (aMode == 'input') {
    jq.setCss('#chaNameDialogTitle', 'display', 'block');
    jq.setCss('#chaNameDialogCheck', 'display', 'block');
    jq.setCss('#chaDivMyName', 'display', 'block');
    if (aChecked != undefined) {
      jq.setCss('#chaNameDialogCheck', 'display', 'block');
      jq.setProp('#chaDivNameArc', 'checked', aChecked);
    } else {
      jq.setCss('#chaNameDialogCheck', 'display', 'none');
    }
    jq.setVal('#chaDivMyName', aMesList[0]);
    jq.setText('#chaNameReq1', aMesList[1]);
    jq.setAttr('#chaDivMyName', 'placeholder', aMesList[2]);
    jq.setText('#chaNameReq2', aMesList[3]);
    jq.setText('#chaNameReq3', aMesList[4]);
    isValid = true;
  } else if (aMode == 'confirm') {
    jq.setCss('#chaNameDialogTitle', 'display', 'none');
    jq.setCss('#chaNameDialogCheck', 'display', 'none');
    jq.setCss('#chaDivMyName', 'display', 'none');
    jq.setText('#chaNameReq1', aMesList[0]);
    jq.setText('#chaNameReq3', aMesList[1]);
    isValid = true;
  }
  if (isValid) jq.setCss('#chaNameDialogBg', 'display', 'block');
}
